// Generated with tools/create-component.js
import React from "react";
import { Carousel, CarouselTypes, CmsContent, Container } from "components";
import { BackgroundColourEnum, ContainerWidthEnum } from "utils";
import { SliderTimelineQueryFragment } from "codegen";
import "./SliderTimeline.scss";

interface SliderTimelineProps {
  data: SliderTimelineQueryFragment;
}

export const SliderTimeline: React.FC<SliderTimelineProps> = ({ data: { heading, slide } }): JSX.Element => {
  const swiperSettings: CarouselTypes = {
    id: "informative-carousel",
    slidesPerView: 1,
    loop: true,
    spaceBetween: "9%",
    grabCursor: false,
    navigation: true,
    breakpoints: {
      600: {
        slidesPerView: 1.7,
        centeredSlides: true,
      },
      1300: {
        slidesPerView: 2.8,
        centeredSlides: true,
      },
      2500: {
        slidesPerView: 3.4,
        centeredSlides: true,
      },
    },
  };

  return (
    <Container
      className="slider-timeline"
      containerWidth={ContainerWidthEnum["FULL_BLEED_LARGE"]}
      backgroundColour={BackgroundColourEnum["PRIMARY"]}
    >
      {heading && <CmsContent content={heading} />}
      {slide && Object.keys(slide).length > 0 && (
        <Carousel swiperSettings={swiperSettings}>
          {slide?.map((item, index) => {
            return (
              <div className="slide" key={index}>
                {item?.year && <span className="slide__giant-year">{item?.year}</span>}
                <div className="slide__content">
                  {item?.year && <p className="typography--h3">{item?.heading}</p>}
                  <div className="slide__content__inner">
                    <CmsContent content={item.content} />
                  </div>
                </div>
              </div>
            );
          })}
        </Carousel>
      )}
    </Container>
  );
};
